import { PendingOrderProductKeys } from '../../interfaces/orderProducts.helper.interfaces';
import {
  GroupByColorClassificationTypeInfo,
  OrderProduct,
  Section,
} from '../../orderProducts.types';

export interface OrderProductsGroupProps {
  orderProducts: OrderProduct[];
  info?: GroupByColorClassificationTypeInfo;
  pendingOrderProductKeys?: PendingOrderProductKeys;
}

abstract class OrderProductsGroupBuilder {
  public abstract group({
    orderProducts,
    info,
    pendingOrderProductKeys,
  }: OrderProductsGroupProps): Section[];
}

export default OrderProductsGroupBuilder;
